import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Formik } from 'formik';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicCheckbox from '../../../../components/BasicCheckbox';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import HorizontalLoader from '../../../../components/HorizontalLoader';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';

const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const RecruiterAggregatedEmailScheduleForm = props => {
  const {
    actions: { handleError, proceed, dismiss },
    onSuccessfulSubmit,
  } = props;

  const api = useApi();

  const [formData, setFormData] = useState({
    init: false,
    fields: { days: [] },
  });

  const [isSaveBtnDisabled, setSaveBtnDisabled] = useState(false);

  useEffect(() => {
    api.get(
      ENDPOINT.FORM.GET.ACCOUNT_RECRUITER_AGGREGATED_EMAIL_SCHEDULE,
      {},
      {
        handleError: response => handleError(response),
        handleSuccess: response => {
          setFormData({ init: true, ...response });
        },
      }
    );
  }, []);

  const handleSubmit = (
    values,
    { setSubmitting, setErrors }
  ) => {
    const days = Object.keys(values.days).filter((k) => values.days[k] === 'Yes')
    api.post(
      ENDPOINT.FORM.SAVE.ACCOUNT_RECRUITER_AGGREGATED_EMAIL_SCHEDULE,
      { days },
      {
        handleError: response => {
          setSubmitting(false);
          handleError(response, setErrors);
        },
        handleSuccess: response => {
          proceed(response);

          if (onSuccessfulSubmit) {
            onSuccessfulSubmit();
          }
        },
      }
    );
  };

  const handleChangeSchedule = (
    field,
    value,
    checked,
    { values, setFieldValue }
  ) => {
    let nextValue = {...values.days};
    if (checked) {
      nextValue[value] = 'Yes';
    } else {
      nextValue[value] = 'No';
    }
    const days = Object.keys(nextValue).filter((k) => nextValue[k] === 'Yes');
    setSaveBtnDisabled(!days.length);
    setFieldValue('days', nextValue);
  };

  return formData.init ? (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik initialValues={formData.fields} onSubmit={handleSubmit}>
          {({ values, handleSubmit, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}
              <div
                className="form__header"
                style={{
                  display: 'flex',
                  padding: '0',
                  alignItems: 'center',
                }}
              >
                <h4 className="setup-email__form-title">Schedule</h4>
              </div>
              {DAYS.map((d, index) => (
                <div className="form__row" key={index}>
                  <BasicCheckbox
                    value={index + 1}
                    singleRow
                    checked={values.days[index + 1] === 'Yes'}
                    title={d}
                    name={d}
                    labelStyles={{
                      fontFamily: 'Noto Sans, sans-serif',
                    }}
                    onChange={(field, value, checked) =>
                      handleChangeSchedule(field, value, checked, {
                        values,
                        setFieldValue,
                      })
                    }
                  />
                </div>
              ))}
              <div
                className="form__controls form__controls--compact"
                style={{ maxWidth: '100%' }}
              >
                <BasicButtonGroup>
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    disabled={isSaveBtnDisabled}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  ) : (
    <div className="form__inner">
      <div className="horizontal-loader__container">
        <HorizontalLoader />
      </div>
    </div>
  );
};

export default RecruiterAggregatedEmailScheduleForm;
